import client from 'utils/client';

const ColorSelectionsMiddleware = store => next => action => {
  if (action.type === 'REQUEST_CHOICES') {
    client.get(`/services/product_groups/${action.groupID}/`).then(resp => {
      store.dispatch({
        type: 'RECEIVE_SETTINGS',
        currency: resp.data.currency,
        vat: resp.data.vat_rate
      });
      store.dispatch({
        type: 'RECEIVE_CHOICES',
        choices: resp.data.subgroups
      });
    });
  }

  if (action.type === 'POST_CHOICES') {
    const arr = [];

    action.choices.map(choice => {
      arr.push({
        product_id: choice.product.id,
        choices_id: choice.choiceID,
        group_id: choice.productGroupID,
        subgroup_id: choice.productSubgroupID
      });
      return arr;
    });

    client
      .post('/services/product_groups/select/', { customer_selected: arr })
      .then(() => {
        client.get(`/services/get_selection/?is_sizes=${true}`).then(resp => {
          store.dispatch({
            type: 'RECEIVE_SIZES',
            sizes: resp.data.subgroups
          });
        });
      });
  }

  if (action.type === 'ADD_SELECTION') {
    store.dispatch({
      type: 'SET_SELECTION',
      selection: {
        choiceID: action.selection.choiceID,
        productGroupID: action.selection.productGroupID,
        product: action.selection.product,
        productSubgroupID: action.selection.productSubgroupID
      }
    });
    store.dispatch({
      type: 'CALCULATE_COLOR_SELECTION',
      props: store.getState().selection
    });
    store.dispatch({
      type: 'COLOR_CAN_CONTINUE',
      props: store.getState().selection
    });
  }

  if (action.type === 'REMOVE_SELECTION') {
    store.dispatch({
      type: 'DELETE_SELECTION',
      productID: action.productID,
      productSubgroupID: action.productSubgroupID
    });
    store.dispatch({
      type: 'CALCULATE_COLOR_SELECTION',
      props: store.getState().selection
    });
    store.dispatch({
      type: 'COLOR_CAN_CONTINUE',
      props: store.getState().selection
    });
  }
  next(action);
};

export default ColorSelectionsMiddleware;
